const pageNameKey = "otaInstallationFailedModal";

export const otaInstallationFailedModalEn = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware: "Close firmware installation failed modal",
    closeModalAriaLabelBackup: "Close backup installation failed modal",
    titleFirmware: "Operation Failed",
    titleBackup: "Operation Failed",
    subtitle: "Operation Failed",
    installationIdLabel: "Installation ID {ID}",
    closeButtonText: "Close",
    installationTypeFirmwareLabel: "Firmware",
    installationTypeBackupLabel: "Backup",
  },
};

export const otaInstallationFailedModalPtBr = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware:
      "Fechar modal de falha na instalação de firmware",
    closeModalAriaLabelBackup: "Fechar modal de falha na instalação de backup",
    titleFirmware: "Operação falhou",
    titleBackup: "Operação falhou",
    subtitle: "Operação falhou",
    installationIdLabel: "ID da instalacao {ID}",
    closeButtonText: "Fechar",
    installationTypeFirmwareLabel: "Firmware",
    installationTypeBackupLabel: "Backup",
  },
};

export const otaInstallationFailedModalDe = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware:
      "Modal für fehlgeschlagene Firmware-Installation schließen",
    closeModalAriaLabelBackup:
      "Modal für fehlgeschlagene Backup-Installation schließen",
    titleFirmware: "Vorgang fehlgeschlagen",
    titleBackup: "Vorgang fehlgeschlagen",
    subtitle: "Vorgang fehlgeschlagen",
    installationIdLabel: "Installations-ID {ID}",
    closeButtonText: "Schließen",
    installationTypeFirmwareLabel: "Firmware",
    installationTypeBackupLabel: "Backup",
  },
};

export const otaInstallationFailedModalZhHans = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware: "关闭固件安装失败弹窗",
    closeModalAriaLabelBackup: "关闭备份安装失败弹窗",
    titleFirmware: "操作失败",
    titleBackup: "操作失败",
    subtitle: "操作失败",
    installationIdLabel: "安装 ID {ID}",
    closeButtonText: "关闭",
    installationTypeFirmwareLabel: "固件",
    installationTypeBackupLabel: "备份",
  },
};

export const otaInstallationFailedModalIt = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware:
      "Chiudi finestra errore installazione firmware",
    closeModalAriaLabelBackup: "Chiudi finestra errore installazione backup",
    titleFirmware: "Operazione non riuscita",
    titleBackup: "Operazione non riuscita",
    subtitle: "Operazione non riuscita",
    installationIdLabel: "ID installazione {ID}",
    closeButtonText: "Chiudi",
    installationTypeFirmwareLabel: "Firmware",
    installationTypeBackupLabel: "Backup",
  },
};

export const otaInstallationFailedModalEs = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware:
      "Cerrar modal de error de instalación de firmware",
    closeModalAriaLabelBackup:
      "Cerrar modal de error de instalación de respaldo",
    titleFirmware: "Operación fallida",
    titleBackup: "Operación fallida",
    subtitle: "Operación fallida",
    installationIdLabel: "ID de instalacion {ID}",
    closeButtonText: "Cerrar",
    installationTypeFirmwareLabel: "Firmware",
    installationTypeBackupLabel: "Respaldo",
  },
};

export const otaInstallationFailedModalNl = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware:
      "Modal voor mislukte firmware-installatie sluiten",
    closeModalAriaLabelBackup: "Modal voor mislukte back-upinstallatie sluiten",
    titleFirmware: "Bewerking mislukt",
    titleBackup: "Bewerking mislukt",
    subtitle: "Bewerking mislukt",
    installationIdLabel: "Installatie-ID {ID}",
    closeButtonText: "Sluiten",
    installationTypeFirmwareLabel: "Firmware",
    installationTypeBackupLabel: "Back-up",
  },
};

export const otaInstallationFailedModalTr = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware: "Firmware yüklemesini kapat başarısız modal",
    closeModalAriaLabelBackup: "Yedekleme yüklemesini kapat başarısız modal",
    titleFirmware: "İşlem Başarısız",
    titleBackup: "İşlem Başarısız",
    subtitle: "İşlem Başarısız",
    closeButtonText: "Kapat",
    installationIdLabel: "Kurulum Kimliği {ID}",
    installationTypeFirmwareLabel: "Ürün yazılımı",
    installationTypeBackupLabel: "Yedekleme",
  },
};
